import { render, staticRenderFns } from "./HomeworkDetails.vue?vue&type=template&id=444567fa&scoped=true"
import script from "./HomeworkDetails.vue?vue&type=script&lang=js"
export * from "./HomeworkDetails.vue?vue&type=script&lang=js"
import style0 from "./HomeworkDetails.vue?vue&type=style&index=0&id=444567fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444567fa",
  null
  
)

export default component.exports